import React, {useState, useEffect} from 'react'
import { Button,Modal, Typography, Box } from '@mui/material'
import axios from 'axios'
import List from "../../shared/list/List"

const CompanySelection = (props) => {

const [openState, setOpenState] = useState(props.open)
const [companies, setCompanies] = useState([])
const [userRole, setUserRole] = useState(localStorage.getItem("userrole"));
const [userCompany, setUserCompany] = useState(localStorage.getItem("usercompany"));

const [search, setSearch] = useState("")

  const getCompanies=()=>{
    axios.get('/companies/selection?search=' + search)
    .then(function (response) {
        if(response.data.status == "success"){
          setCompanies(response.data.data);
        }
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  useEffect(()=>{
    if(userRole == "Admin" && companies.length == 0){
      getCompanies();
    }
  })

  const handleClose=()=>{
    props.setOpenState(false)
  }

  const handleOnCellClick = (params) => {
    setUserCompany(params.row.Id);
    localStorage.setItem("usercompany", params.row.Id);
    localStorage.setItem("usercompanylogo", params.row.Logo);
    localStorage.setItem("usercompanyname", params.row.Name);

    axios.get('/companies/select?id=' + params.row.Id)
    .then(function (response) {
        handleClose();
        window.location = "/";
    })
    .catch(function (error) {
      console.error(error);
    });
  };

  const model = {
    columns: [
      {
        field: "Name",
        headerName: "Company",
        width: "600",
        renderCell: (params) => {
          return (
            <div className="cellWithImg" onClick={()=> handleOnCellClick(params)}>
              <img className="cellImg company-image" src={axios.defaults.baseURL + '/' + params.row.Logo} alt="avatar" />
              <a className="cellWithLink"> {params.row.Name}</a>
            </div>
          );
        },
      }
    ],
    modulename: "Companies"
  };

  return (
    <div>
        <Modal
        open={openState}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
        <Box sx={{ mt: 10, ml: 60, mr: 40, padding: 2, height: 500, width: 650, backgroundColor: "#f6f6f6"}}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
            Companies
            </Typography>
            <div id="modal-modal-description">
                <List {...model} rows={companies} setSearch={setSearch} setCompanies={setCompanies} />
            </div>
        </Box>
        </Modal>
    </div>
  )
}

export default CompanySelection
